import SelectDropdown from '../../Search/Inputs/SelectDropdown';
import { useTranslation } from 'react-i18next';

export default function BusinesslineSelect(props) {
  const options = props.options.map(item => {
    return {label: item.name, value: item.id};
  });

  const { t, i18n } = useTranslation();

  return(
    <SelectDropdown id="businesslines" label={t('industry')} name="businesslines[]" options={options} checked={props.checked}/>
  );
};
